import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import CurrencyForm from "./CurrencyForm";
import currencies from "../../models/currencies";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function CurrencyAdd() {
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()

    const [fields, setFields] = useState({})
    const [errors, setErrors] = useState({});

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof currencies.fieldValidator[name] === 'function'
        && currencies.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = currencies.methodValidator.add(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        currencies.add(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/currencies')
            }).catch(() => setShowLoader(false))
    }


    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Add currency" breadcrumbs={[['Dashboard', '/'], ['Currencies', '/currencies'], ['Add', '/currencies/add']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <CurrencyForm fields={fields} errors={errors} handleChange={handleChange}
                              handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}